"use strict";
/*
 * Created on 20. 1. 2021
 *
 * Copyright (c) 2021 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EcommerceAppConfig_1 = require("../EcommerceAppConfig");

var ManualSplitsAppConfig_1 = require("../ManualSplitsAppConfig");

var OpeningAppConfig_1 = require("../OpeningAppConfig");

var PromotionAppConfig_1 = require("../PromotionAppConfig");

var PromotionAppConfigConverter_1 = require("./PromotionAppConfigConverter");
/**
 * Default implementation of {@link PromotionAppConfigConverter}.
 *
 * @author Radek Beran
 * @author Tomas Leity
 */


var PromotionAppConfigConverterImpl =
/*#__PURE__*/
function (_PromotionAppConfigCo) {
  _inherits(PromotionAppConfigConverterImpl, _PromotionAppConfigCo);

  function PromotionAppConfigConverterImpl() {
    _classCallCheck(this, PromotionAppConfigConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionAppConfigConverterImpl).apply(this, arguments));
  }

  _createClass(PromotionAppConfigConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromotionAppConfig_1.PromotionAppConfig(PromotionAppConfig_1.PromotionAppConfig.schema.opening.valueOf(conversions.asObject(source, 'opening', PromotionAppConfigConverterImpl.deserializeOpeningAppConfig(conversions))), PromotionAppConfig_1.PromotionAppConfig.schema.ecommerce.valueOf(conversions.asObject(source, 'ecommerce', PromotionAppConfigConverterImpl.deserializeEcommerceAppConfig(conversions))), PromotionAppConfig_1.PromotionAppConfig.schema.manualSplits.valueOf(conversions.asObject(source, 'manualSplits', PromotionAppConfigConverterImpl.deserializeManualSplitsAppConfig(conversions))));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        opening: conversions.asObject(source, 'opening', PromotionAppConfigConverterImpl.serializeOpeningAppConfig(conversions)),
        ecommerce: conversions.asObject(source, 'ecommerce', PromotionAppConfigConverterImpl.serializeEcommerceAppConfig(conversions)),
        manualSplits: conversions.asObject(source, 'manualSplits', PromotionAppConfigConverterImpl.serializeManualSplitsAppConfig(conversions))
      });
      return result;
    }
    /**
     * Getter for {@link OpeningAppConfig} serializer
     */

  }], [{
    key: "serializeOpeningAppConfig",
    value: function serializeOpeningAppConfig(conversions) {
      return function (object) {
        return {
          enabled: object.enabled,
          promotionTypeId: object.promotionTypeId
        };
      };
    }
    /**
     * Getter for {@link OpeningAppConfig} deserializer
     */

  }, {
    key: "deserializeOpeningAppConfig",
    value: function deserializeOpeningAppConfig(conversions) {
      return function (document) {
        return new OpeningAppConfig_1.OpeningAppConfig(OpeningAppConfig_1.OpeningAppConfig.schema.enabled.valueOfField(document), OpeningAppConfig_1.OpeningAppConfig.schema.promotionTypeId.valueOfField(document));
      };
    }
    /**
     * Getter for {@link EcommerceAppConfig} serializer
     */

  }, {
    key: "serializeEcommerceAppConfig",
    value: function serializeEcommerceAppConfig(conversions) {
      return function (object) {
        return {
          enabled: object.enabled,
          promotionTypeId: object.promotionTypeId,
          groupOfSiteId: object.groupOfSiteId
        };
      };
    }
    /**
     * Getter for {@link EcommerceAppConfig} deserializer
     */

  }, {
    key: "deserializeEcommerceAppConfig",
    value: function deserializeEcommerceAppConfig(conversions) {
      return function (document) {
        return new EcommerceAppConfig_1.EcommerceAppConfig(EcommerceAppConfig_1.EcommerceAppConfig.schema.enabled.valueOfField(document), EcommerceAppConfig_1.EcommerceAppConfig.schema.promotionTypeId.valueOfField(document), EcommerceAppConfig_1.EcommerceAppConfig.schema.groupOfSiteId.valueOfField(document));
      };
    }
    /**
     * Getter for {@link ManualSplitsAppConfig} serializer
     */

  }, {
    key: "serializeManualSplitsAppConfig",
    value: function serializeManualSplitsAppConfig(conversions) {
      return function (object) {
        return {
          enabled: object.enabled
        };
      };
    }
    /**
     * Getter for {@link ManualSplitsAppConfig} deserializer
     */

  }, {
    key: "deserializeManualSplitsAppConfig",
    value: function deserializeManualSplitsAppConfig(conversions) {
      return function (document) {
        return new ManualSplitsAppConfig_1.ManualSplitsAppConfig(ManualSplitsAppConfig_1.ManualSplitsAppConfig.schema.enabled.valueOfField(document));
      };
    }
  }]);

  return PromotionAppConfigConverterImpl;
}(PromotionAppConfigConverter_1.PromotionAppConfigConverter);

exports.PromotionAppConfigConverterImpl = PromotionAppConfigConverterImpl;